export const ROUTES = {
    DEFAULT: '',
    HOME_ENABLING_BUSINESS_CAROUSEL: 'content/enabling-your-business-carousel',
    HOME_INFO_GUIDES_CAROUSEL: 'content/info-guides-carousel',
    NOTICE_BANNER: 'content/notice-banner',
    REGISTRY_INSTRUCTION_INTRO: 'registry-instruction-intro',
    PAGE_LOADER_TEST: 'page-loader-test',
    INFORMATION_PRODUCTS: 'information-products',
    BUY_INFO: 'buy-info',
    SEO: 'seo',
};
